import AxiosInstance, { takeLatestRequest } from "@/config/AxiosInstance";
import { API_BASE_URL_OPEN, API_BASE_URL_ADMIN } from "@/config/appConfig";

type AuthRequestPayload = Record<string, unknown>;
type LatestRequestConfig = {
  headers?: Record<string, string>;
  method: string;
  url: string;
};

export const authService = {
  login,
  openLogout,
  forgotPassword,
  validateResetPassToken,
  resetPassword,
  checkCurrentPassword,
  updatePassword,
  changePassTempToPermanent,
  validateLinkToken,
  setNewPassword,
  resendToken,
  signUp,
  getAccessToken,
};

function login(user: AuthRequestPayload) {
  return AxiosInstance.post(`${API_BASE_URL_OPEN}/login`, user);
}

function openLogout(data: AuthRequestPayload) {
  return AxiosInstance.post(`${API_BASE_URL_OPEN}/logout`, data);
}

function forgotPassword(email: AuthRequestPayload) {
  return AxiosInstance.post(`${API_BASE_URL_OPEN}/forgotPassword`, email);
}

function validateResetPassToken(token: string) {
  const sanitizedToken = encodeURIComponent(token.trim());
  return AxiosInstance.get(
    `${API_BASE_URL_OPEN}/forgotPassword?token=${sanitizedToken}`
  );
}

function resetPassword(data: AuthRequestPayload) {
  return AxiosInstance.put(`${API_BASE_URL_OPEN}/forgotPassword`, data);
}

function checkCurrentPassword(data: AuthRequestPayload) {
  return AxiosInstance.patch(`${API_BASE_URL_ADMIN}/checkpassword`, data);
}

function updatePassword(data: AuthRequestPayload) {
  return AxiosInstance.patch(`${API_BASE_URL_ADMIN}/updatePassword`, data);
}

function changePassTempToPermanent(data: AuthRequestPayload) {
  return AxiosInstance.post(
    `${API_BASE_URL_ADMIN}/changePassTempToPermanent`,
    data,
    { suppressToast: true } as any
  );
}

function validateLinkToken(token: string) {
  return AxiosInstance.get(`${API_BASE_URL_OPEN}/verifyToken?token=${token}`);
}

function setNewPassword(data: AuthRequestPayload) {
  return AxiosInstance.put(`${API_BASE_URL_OPEN}/setNewPassword`, data);
}

function resendToken(data: AuthRequestPayload) {
  return AxiosInstance.post(`${API_BASE_URL_OPEN}/resendToken`, data);
}

function signUp(data: AuthRequestPayload) {
  return AxiosInstance.post(`${API_BASE_URL_OPEN}/signUp`, data);
}

function getAccessToken(token: string | null = null) {
  const config: LatestRequestConfig = {
    method: "get",
    url: `${API_BASE_URL_ADMIN}/getRandomTokenGenerate`,
  };
  if (token) {
    config.headers = {
      Authorization: `Bearer ${token}`,
    };
  }
  return takeLatestRequest(config, "getRandomTokenGenerate");
}
